import { Container } from "@mantine/core"
import { Loader, MultiSelect } from "@tfg/ui"
import { useState } from "react"

type Props = {
  data: { value: string; label: string }[] | string[]
  initialValues: string[]
  isLoading: boolean
  onChange: (value: string[]) => void
  key: number | string
}
export function MultiSelectCell({
  data,
  initialValues,
  isLoading,
  key,
  onChange,
}: Props) {
  const [values, setValues] = useState(initialValues)
  return (
    <Container miw={300}>
      {!isLoading ? (
        <MultiSelect
          data={data}
          key={key}
          value={values}
          searchable
          onChange={(value) => {
            setValues(value)
            onChange(value)
          }}
        />
      ) : (
        <Loader type="dots" />
      )}
    </Container>
  )
}
